import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import DQLAB_logo from '../../../assets/images/DQLAB_logo.png';

// Create styles
const styles = StyleSheet.create({
    page: {
        padding: 40,
        fontFamily: 'Helvetica',
        fontSize: 10,
        backgroundColor: '#ffffff',
    },
    companyHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 25,
        paddingBottom: 15,
        borderBottom: '2px solid #e0e0e0',
    },
    companyLogo: {
        height: 50,
        width: 'auto',
        maxWidth: 120,
        objectFit: 'contain',
        marginRight: 15,
    },
    companyInfo: {
        flex: 1,
    },
    companyName: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#000000',
        marginBottom: 5,
    },
    companyAddress: {
        fontSize: 10,
        color: '#666666',
        lineHeight: 1.5,
    },
    header: {
        marginBottom: 20,
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        color: '#000000',
        marginBottom: 5,
    },
    invoiceInfoBox: {
        backgroundColor: '#f9f9f9',
        padding: 15,
        borderRadius: 8,
        marginBottom: 25,
    },
    invoiceNumber: {
        fontSize: 10,
        fontWeight: 'bold',
        color: '#ff6468',
        marginBottom: 10,
    },
    fromToRow: {
        flexDirection: 'row',
        gap: 30,
        marginTop: 10,
    },
    fromToItem: {
        flex: 1,
    },
    fromToLabel: {
        fontSize: 9,
        color: '#666666',
        fontWeight: 'bold',
        marginBottom: 3,
    },
    fromToValue: {
        fontSize: 11,
        fontWeight: 'bold',
        color: '#000000',
    },
    additionalOrgs: {
        fontSize: 8,
        color: '#666666',
        marginTop: 2,
    },
    invoiceInfoRow: {
        flexDirection: 'row',
        gap: 30,
    },
    infoItem: {
        marginRight: 30,
    },
    infoLabel: {
        fontSize: 9,
        color: '#666666',
        marginBottom: 3,
    },
    infoValue: {
        fontSize: 11,
        fontWeight: 'bold',
        color: '#000000',
    },
    statusBadgeInfo: {
        backgroundColor: '#ff6468',
        color: '#ffffff',
        padding: '3px 8px',
        borderRadius: 4,
        fontSize: 9,
        fontWeight: 'bold',
    },
    sectionTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#000000',
        marginBottom: 15,
        marginTop: 20,
    },
    summaryContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 20,
        gap: 15,
    },
    summaryBox: {
        flex: 1,
        border: '1px solid #e0e0e0',
        borderRadius: 8,
        padding: 15,
        backgroundColor: '#f9f9f9',
    },
    summaryLabel: {
        fontSize: 11,
        color: '#666666',
        marginBottom: 5,
    },
    summaryValue: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#000000',
    },
    invoiceDetailsRow: {
        backgroundColor: '#f9f9f9',
        padding: 15,
        borderRadius: 8,
        marginBottom: 20,
        flexDirection: 'row',
        justifyContent: 'space-around',
        gap: 30,
    },
    table: {
        marginTop: 10,
        marginBottom: 20,
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#f5f5f5',
        borderBottom: '2px solid #000000',
        paddingVertical: 8,
        paddingHorizontal: 5,
    },
    tableRow: {
        flexDirection: 'row',
        borderBottom: '1px solid #e0e0e0',
        paddingVertical: 10,
        paddingHorizontal: 5,
    },
    tableHeaderCell: {
        fontSize: 10,
        fontWeight: 'bold',
        color: '#000000',
    },
    tableCell: {
        fontSize: 9,
        color: '#333333',
    },
    colOrganization: {
        width: '35%',
    },
    colDQP: {
        width: '15%',
        textAlign: 'center',
    },
    colUsers: {
        width: '15%',
        textAlign: 'center',
    },
    colStatus: {
        width: '18%',
        textAlign: 'center',
    },
    colLastUpdate: {
        width: '17%',
        textAlign: 'center',
    },
    colSessions: {
        width: '15%',
        textAlign: 'center',
    },
    statusBadge: {
        backgroundColor: '#FFA500',
        color: '#ffffff',
        padding: '4px 8px',
        borderRadius: 4,
        fontSize: 8,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    colProgramName: {
        width: '40%',
    },
    colProgramCode: {
        width: '30%',
    },
    colCost: {
        width: '15%',
        textAlign: 'center',
    },
    colCreatedAt: {
        width: '15%',
        textAlign: 'center',
    },
    totalRow: {
        flexDirection: 'row',
        backgroundColor: '#f9f9f9',
        borderTop: '2px solid #000000',
        paddingVertical: 10,
        paddingHorizontal: 5,
        fontWeight: 'bold',
    },
    totalCell: {
        fontSize: 10,
        fontWeight: 'bold',
        color: '#000000',
    },
    totalAmount: {
        fontSize: 11,
        fontWeight: 'bold',
        color: '#ff6468',
    },
    programSection: {
        marginTop: 15,
        marginBottom: 15,
        paddingLeft: 10,
    },
    programHeader: {
        fontSize: 12,
        fontWeight: 'bold',
        color: '#000000',
        marginBottom: 10,
        backgroundColor: '#f9f9f9',
        padding: 8,
        borderLeft: '3px solid #ff6468',
    },
    programItem: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 8,
        paddingHorizontal: 10,
        borderBottom: '1px solid #f0f0f0',
    },
    programName: {
        fontSize: 10,
        color: '#333333',
        flex: 1,
    },
    programAudience: {
        fontSize: 8,
        color: '#666666',
        marginTop: 2,
    },
    programStats: {
        flexDirection: 'row',
        gap: 20,
        alignItems: 'center',
    },
    statItem: {
        alignItems: 'center',
    },
    statValue: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#ff6468',
    },
    statLabel: {
        fontSize: 8,
        color: '#666666',
        marginTop: 2,
    },
    divider: {
        borderBottom: '1px solid #e0e0e0',
        marginVertical: 15,
    },
    footer: {
        position: 'absolute',
        bottom: 30,
        left: 40,
        right: 40,
        textAlign: 'center',
        fontSize: 8,
        color: '#999999',
        borderTop: '1px solid #e0e0e0',
        paddingTop: 10,
    },
});

const InvoicePdfDoc = ({ invoiceData, programNameMap = {}, dqInsiderInfo }) => {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: '2-digit', 
            day: '2-digit' 
        });
    };

    const formatAmount = (amount) => {
        const num = Number(amount) || 0;
        return num.toFixed(2);
    };

    // Calculate summary totals
    const totalOrganizations = invoiceData.organizations?.length || 0;
    const totalDQP = invoiceData.organizations?.reduce((sum, org) => sum + (org.dqp || 0), 0) || 0;
    const totalUsers = invoiceData.organizations?.reduce((sum, org) => sum + (org.users || 0), 0) || 0;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* Company Header with Logo */}
                <View style={styles.companyHeader}>
                    <Image src={DQLAB_logo} style={styles.companyLogo} />
                    <View style={styles.companyInfo}>
                        <Text style={styles.companyName}>DQ LAB Pte. Ltd</Text>
                        <Text style={styles.companyAddress}>
                            20A Tanjong Pagar Road, Singapore 088443
                        </Text>
                    </View>
                </View>

                {/* Header */}
                <View style={styles.header}>
                    <Text style={styles.title}>
                        Invoice Details - {invoiceData.month || 'N/A'}
                    </Text>
                </View>

                {/* Invoice Info */}
                <View style={styles.invoiceInfoBox}>
                    <View style={styles.fromToRow}>
                        <View style={styles.fromToItem}>
                            <Text style={styles.fromToLabel}>Invoice Number</Text>
                            <Text style={styles.invoiceNumber}>
                                {invoiceData.invoice_number}
                            </Text>
                        </View>

                        {/* Bill To Section */}
                        <View style={styles.fromToItem}>
                            <Text style={styles.fromToLabel}>Bill To</Text>
                            <Text style={styles.fromToValue}>
                                {dqInsiderInfo?.profile?.profile_type === 'BUSINESS'
                                    ? dqInsiderInfo.profile.business_name || 'Business Name Not Available'
                                    : dqInsiderInfo?.profile?.first_name && dqInsiderInfo?.profile?.last_name
                                        ? `${dqInsiderInfo.profile.first_name} ${dqInsiderInfo.profile.last_name}`
                                        : dqInsiderInfo?.user?.email || 'DQ Insider'}
                            </Text>
                            {dqInsiderInfo?.user?.email && (
                                <Text style={{ fontSize: 9, color: '#666666', marginTop: 2 }}>
                                    {dqInsiderInfo.user.email}
                                </Text>
                            )}
                            {dqInsiderInfo?.profile?.address && (
                                <Text style={{ fontSize: 9, color: '#666666', marginTop: 2 }}>
                                    {dqInsiderInfo.profile.address}
                                </Text>
                            )}
                            {(dqInsiderInfo?.profile?.city || dqInsiderInfo?.profile?.postal_code) && (
                                <Text style={{ fontSize: 9, color: '#666666', marginTop: 2 }}>
                                    {[dqInsiderInfo.profile.city, dqInsiderInfo.profile.postal_code].filter(Boolean).join(', ')}
                                </Text>
                            )}
                            {dqInsiderInfo?.profile?.country && (
                                <Text style={{ fontSize: 9, color: '#666666', marginTop: 2 }}>
                                    {dqInsiderInfo.profile.country}
                                </Text>
                            )}
                        </View>
                    </View>
                </View>

                {/* Monthly Summary */}
                <Text style={styles.sectionTitle}>Monthly Summary</Text>
                <View style={styles.summaryContainer}>
                    <View style={styles.summaryBox}>
                        <Text style={styles.summaryLabel}>Organizations</Text>
                        <Text style={styles.summaryValue}>{totalOrganizations}</Text>
                    </View>
                    <View style={styles.summaryBox}>
                        <Text style={styles.summaryLabel}>Total Licenses</Text>
                        <Text style={styles.summaryValue}>{totalDQP}</Text>
                    </View>
                    <View style={styles.summaryBox}>
                        <Text style={styles.summaryLabel}>Total Users</Text>
                        <Text style={styles.summaryValue}>{totalUsers}</Text>
                    </View>
                </View>

                {/* Invoice Details Row */}
                <View style={styles.invoiceDetailsRow}>
                    <View style={styles.infoItem}>
                        <Text style={styles.infoLabel}>Date</Text>
                        <Text style={styles.infoValue}>{formatDate(invoiceData.date)}</Text>
                    </View>
                    <View style={styles.infoItem}>
                        <Text style={styles.infoLabel}>Status</Text>
                        <Text style={styles.statusBadgeInfo}>{invoiceData.status}</Text>
                    </View>
                    <View style={styles.infoItem}>
                        <Text style={styles.infoLabel}>Total Invoice Amount</Text>
                        <Text style={[styles.infoValue, { color: '#ff6468' }]}>{invoiceData.currency} ${formatAmount(invoiceData.total_amount)}</Text>
                    </View>
                </View>

                {/* Programs Created This Month */}
                {invoiceData.programs_created && invoiceData.programs_created.length > 0 && (
                    <>
                        <Text style={styles.sectionTitle}>Programs Created This Month</Text>
                        <View style={styles.table}>
                            <View style={styles.tableHeader}>
                                {/*<Text style={[styles.tableHeaderCell, { width: '25%' }]}>Organization</Text>*/}
                                <Text style={[styles.tableHeaderCell, { width: '30%' }]}>Program Name</Text>
                                <Text style={[styles.tableHeaderCell, { width: '30%' }]}>Program Code</Text>
                                <Text style={[styles.tableHeaderCell, { width: '12%', textAlign: 'center' }]}>Sessions</Text>
                                <Text style={[styles.tableHeaderCell, { width: '15%', textAlign: 'center' }]}>Cost (USD)</Text>
                                <Text style={[styles.tableHeaderCell, { width: '13%', textAlign: 'center' }]}>Created</Text>
                            </View>
                            {invoiceData.programs_created.map((program, index) => (
                                <View key={index} style={styles.tableRow}>
                                    {/*<View style={[styles.tableCell, { width: '25%' }]}>*/}
                                    {/*    <Text style={{ fontSize: 9, fontWeight: 'bold' }}>{program.org_name}</Text>*/}
                                    {/*    <Text style={{ fontSize: 7, color: '#666666' }}>({program.org_code})</Text>*/}
                                    {/*</View>*/}
                                    <Text style={[styles.tableCell, { width: '30%' }]}>
                                        {program.program_name}
                                    </Text>
                                    <Text style={[styles.tableCell, { width: '30%' }]}>
                                        {program.program_code}
                                    </Text>
                                    <Text style={[styles.tableCell, { width: '12%', textAlign: 'center' }]}>
                                        {program.no_of_sessions}
                                    </Text>
                                    <Text style={[styles.tableCell, { width: '15%', textAlign: 'center' }]}>
                                        ${formatAmount(program.cost)}
                                    </Text>
                                    <Text style={[styles.tableCell, { width: '13%', textAlign: 'center', fontSize: 7 }]}>
                                        {formatDate(program.created_at)}
                                    </Text>
                                </View>
                            ))}
                            <View style={styles.totalRow}>
                                <Text style={[styles.totalCell, { width: '72%', textAlign: 'right', paddingRight: 10 }]}>
                                    Total Program Creation Cost:
                                </Text>
                                <Text style={[styles.totalAmount, { width: '15%', textAlign: 'center' }]}>
                                    ${formatAmount(invoiceData.programs_created.reduce((sum, p) => sum + (p.cost || 0), 0))}
                                </Text>
                                <Text style={{ width: '13%' }}></Text>
                            </View>
                        </View>
                    </>
                )}

                {/* Assessments Created This Month */}
                {invoiceData.assessments_created && invoiceData.assessments_created.length > 0 && (
                    <>
                        <Text style={styles.sectionTitle}>Assessments Created This Month</Text>
                        <View style={styles.table}>
                            <View style={styles.tableHeader}>
                                <Text style={[styles.tableHeaderCell, { width: '35%' }]}>Assessment Name</Text>
                                <Text style={[styles.tableHeaderCell, { width: '35%' }]}>Assessment Code</Text>
                                <Text style={[styles.tableHeaderCell, { width: '15%', textAlign: 'center' }]}>Cost (USD)</Text>
                                <Text style={[styles.tableHeaderCell, { width: '15%', textAlign: 'center' }]}>Created</Text>
                            </View>
                            {invoiceData.assessments_created.map((assessment, index) => (
                                <View key={index} style={styles.tableRow}>
                                    <Text style={[styles.tableCell, { width: '35%' }]}>
                                        {assessment.assessment_name}
                                    </Text>
                                    <Text style={[styles.tableCell, { width: '35%' }]}>
                                        {assessment.assessment_code}
                                    </Text>
                                    <Text style={[styles.tableCell, { width: '15%', textAlign: 'center' }]}>
                                        ${formatAmount(assessment.cost)}
                                    </Text>
                                    <Text style={[styles.tableCell, { width: '15%', textAlign: 'center', fontSize: 7 }]}>
                                        {formatDate(assessment.created_at)}
                                    </Text>
                                </View>
                            ))}
                            <View style={styles.totalRow}>
                                <Text style={[styles.totalCell, { width: '70%', textAlign: 'right', paddingRight: 10 }]}>
                                    Total Assessment Creation Cost:
                                </Text>
                                <Text style={[styles.totalAmount, { width: '15%', textAlign: 'center' }]}>
                                    ${formatAmount(invoiceData.assessments_created.reduce((sum, a) => sum + (a.cost || 0), 0))}
                                </Text>
                                <Text style={{ width: '15%' }}></Text>
                            </View>
                        </View>
                    </>
                )}

                {/* Organization Breakdown */}
                <Text style={styles.sectionTitle}>Organization Breakdown</Text>
                <View style={styles.table}>
                    <View style={styles.tableHeader}>
                        <Text style={[styles.tableHeaderCell, styles.colOrganization]}>Organization</Text>
                        <Text style={[styles.tableHeaderCell, styles.colDQP]}>Licenses</Text>
                        <Text style={[styles.tableHeaderCell, styles.colUsers]}>Users</Text>
                        <Text style={[styles.tableHeaderCell, styles.colSessions]}>Amount</Text>
                        <Text style={[styles.tableHeaderCell, styles.colStatus]}>Status</Text>
                    </View>
                    {invoiceData.organizations?.map((org, index) => (
                        <View key={index} style={styles.tableRow}>
                            <Text style={[styles.tableCell, styles.colOrganization]}>
                                {org.name}
                            </Text>
                            <Text style={[styles.tableCell, styles.colDQP]}>{org.dqp}</Text>
                            <Text style={[styles.tableCell, styles.colUsers]}>{org.users}</Text>
                            <Text style={[styles.tableCell, styles.colSessions]}>${formatAmount(org.amount)}</Text>
                            <Text style={[styles.tableCell, styles.colStatus]}>
                                <Text style={styles.statusBadge}>{org.status}</Text>
                            </Text>
                        </View>
                    ))}
                    {/* Total Row */}
                    <View style={styles.totalRow}>
                        <Text style={[styles.totalCell, styles.colOrganization]}>Total</Text>
                        <Text style={[styles.totalCell, styles.colDQP]}>
                            {invoiceData.organizations?.reduce((sum, org) => sum + (org.programs?.length || 0), 0) || 0}
                        </Text>
                        <Text style={[styles.totalCell, styles.colUsers]}>
                            {invoiceData.organizations?.reduce((sum, org) => sum + (org.users || 0), 0) || 0}
                        </Text>
                        <Text style={[styles.totalAmount, styles.colSessions]}>
                            ${formatAmount(invoiceData.organizations?.reduce((sum, org) => sum + (org.amount || 0), 0) || 0)}
                        </Text>
                        <Text style={[styles.totalCell, styles.colStatus]}></Text>
                    </View>
                </View>

                {/* Program Breakdown */}
                <Text style={styles.sectionTitle}>Program Breakdown</Text>
                {invoiceData.organizations?.map((org, orgIndex) => (
                    <View key={orgIndex} style={styles.programSection}>
                        <Text style={styles.programHeader}>
                            {org.name} ({org.org_code})
                        </Text>
                        {org.programs && org.programs.length > 0 ? (
                            org.programs.map((program, progIndex) => (
                                <View key={progIndex} style={styles.programItem}>
                                    <View style={styles.programName}>
                                        <Text>{programNameMap[program.code] || program.code}</Text>
                                        <Text>({program.code})</Text>
                                        <Text style={styles.programAudience}>{program.targetAudience}</Text>
                                    </View>
                                    <View style={styles.programStats}>
                                        <View style={styles.statItem}>
                                            <Text style={styles.statValue}>{program.dqp || 0}</Text>
                                            <Text style={styles.statLabel}>Licenses</Text>
                                        </View>
                                        <View style={styles.statItem}>
                                            <Text style={styles.statValue}>{program.users || 0}</Text>
                                            <Text style={styles.statLabel}>Users</Text>
                                        </View>
                                        <View style={styles.statItem}>
                                            <Text style={styles.statValue}>${formatAmount(program.amount)}</Text>
                                            <Text style={styles.statLabel}>Amount</Text>
                                        </View>
                                    </View>
                                </View>
                            ))
                        ) : (
                            <Text style={{ fontSize: 9, color: '#666666', padding: 10 }}>
                                No programs found for this organization
                            </Text>
                        )}
                    </View>
                ))}
            </Page>
        </Document>
    );
};

export default InvoicePdfDoc;

